export default __webpack_public_path__ + "static/media/voiceping_app.b99da0d3.png";